<template>
  <b-modal
    id="modal-nova-permissao"
    v-model="showModal"
    title="Novo cargo"
    centered
    @hidden="resetForm"
  >
    <div class="row">
      <div class="col-12">
        <label class="dbo-ui">Nome da novo cargo</label>
        <input 
          type="text" 
          v-model="form.name" 
          class="form-control" 
          placeholder="Digite o nome do cargo" 
        />
      </div>
    </div>
    
    <template #modal-footer>
      <b-button 
        variant="secondary" 
        @click="closeModal"
      >
        <i class="fa fa-times mr-1"></i> Cancelar
      </b-button>
      <b-button 
        variant="primary" 
        @click="savePermission" 
        :disabled="!form.name"
      >
        <i class="fa fa-check mr-1"></i> Salvar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'NewPermissionModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        name: ''
      }
    };
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    
    resetForm() {
      this.form = {
        name: ''
      };
    },
    
    savePermission() {
      const roleData = { ...this.form };
      this.$emit('save', roleData);
      this.closeModal();
    }
  }
};
</script>

<style scoped>
.dbo-ui {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
}
</style>